export class AutocompleteCliente {
    idCliente: number;
    nombre: string;
    numCliente: string;
}